import React from 'react';
import PropTypes from 'prop-types';


class RhinoModal extends React.Component {

  static defaultProps = {
    open: false,
    resize: 0,
  };

  static propTypes = {
    open: PropTypes.bool,
    resize: PropTypes.number,
  };

  constructor(props) {
    super(props);
    this.state = {
      open: false,
      closing: false,
      bodyTop: 0,
      marginOffset: 0,
    };

    // Bind event listeners
    this.adjustHeight = ::this.adjustHeight;
    this.checkClick = ::this.checkClick;
  }

  componentWillMount() {
    window.addEventListener('resize', this.adjustHeight, false);
    // window.addEventListener('click', this.checkClick, false);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.adjustHeight, false);
    // window.removeEventListener('click', this.checkClick, false);
  }

  checkClick(evt) {

    if(this.state.open === true) {
      let targetElement = evt.target;

      do {
          if (targetElement == this.modalBodyElement) {
              return;
          }
          targetElement = targetElement.parentNode;
      } while (targetElement);

      console.log('should close');
      // This is a click outside, should close
      this.closeModal();
    }
  }

  componentWillUpdate(nextProps, nextState) {
    if(this.state.open !== nextProps.open) {
      if(this.state.open && !nextProps.open && !this.state.closing) {
        this.closeModal();
      } 
      if(nextProps.open) {
        this.openModal();
      }
    }
    if(this.props.resize != nextProps.resize) {
      this.adjustHeight();
    }
  }

  getModalBody() {
    let modal = null;
    let modals = document.getElementsByClassName('modalBody');
    for(let i = 0; i < modals.length; i++) {
      if(getComputedStyle(modals[i], null).display === 'block') {
        modal = modals[i];
        break;
      }
    }
    return modal;
  }

  adjustHeight() {
    let foundModal = this.getModalBody();
    if(foundModal) {
      let offset = (window.innerHeight - (foundModal.offsetHeight + 128)) / 2;
      this.setState({ marginOffset: offset > 0 ? offset + 'px' : 0 });
    }
  }

  openModal() {
    this.setState({ open: true }, () => {
      let modal = null;
      do {
        modal = this.getModalBody();
        setTimeout(() => {
          if(modal) {
            let offset = (window.innerHeight - (modal.offsetHeight + 128)) / 2;
            this.setState({ 
              bodyTop: '64px',
              marginOffset: offset > 0 ? offset + 'px' : 0, 
            });
          }
        }, 25);
      } while(!modal);
    });
  }

  closeModal() {
    this.setState({ 
      closing: true,
      bodyTop: '0',
    });
    setTimeout(() => {
      this.setState({
        open: false,
        closing: false,
      });
    }, 400)
  }

  modalStyles() {
    return {
      display: this.state.open ? 'block' : 'none', 
    }
  }

  render() {

    return (
      <div 
        className={this.state.closing ? 'RhinoModal out' : 'RhinoModal'} 
        style={this.modalStyles()}>
        <div 
          className='modalBody'
          style={{
            display: this.state.open ? 'block' : 'none',
            top: this.state.bodyTop,
            marginTop: this.state.marginOffset,
            marginBottom: this.state.marginOffset === 0 ? '64px' : 0,
          }}
          ref={(modalBodyElement) => { this.modalBodyElement = modalBodyElement; }}>
          {this.props.title ?
            <div className={'modalTitle modalTitlePositioning'}>{this.props.title}</div> :
            null
          }
          <div className='modalChildren'>{this.props.children}</div>
          {this.props.actions ?
            <div className={'modalActions modalActionsPositioning'}>
              {this.props.actions.map(action => {
                return action;
              })}
            </div> :
            null
          }
        </div>
      </div>
    );



  }
}
export default RhinoModal;